import { useEffect, useState } from 'react'
import { loadZohoSalesIQ } from '../utils/zohoSalesIQ'

/**
 * Custom hook to mount Zoho SalesIQ widget
 * @param {Object} user - The authenticated user object
 * @returns {Object} - { initialised: boolean, sdk: object|null }
 */
const useMountZohoSIQ = (user) => {
    const [state, setState] = useState({
        initialised: false,
        sdk: null,
    })

    const callback = () => {
        setState({
            initialised: true,
            sdk: window.$zoho,
        })
    }

    useEffect(() => {
        if (!user) return

        loadZohoSalesIQ(user, callback)
    }, [user])

    return state
}

export default useMountZohoSIQ
